/**
 * Exact colors from POS client (orders.co-pos-client) theme.
 * Source: src/theme/colors.ts and src/theme/theme.ts
 * Use these everywhere in Preview so UI matches POS.
 */

export const POS_COLORS = {
  // Primary / text
  BLACK: '#3D3D3D',
  BLACK_SECONDARY: '#646464',
  PRIMARY: '#3D3D3D',
  WHITE: 'white',

  // Greys / surfaces
  BLACK_DISABLE: '#E7E7E7',
  DISABLE: '#E7E7E7',
  GRAY_BACKGROUND: '#E2E2E2',
  SURFACE: '#F1F1F1',
  GREY_SECONDARY: '#929398',
  GRAY_SLIDE: '#B5B5B5',
  DIVIDER: '#E0E0E0',
  dividerNew: '#C5C5C5',
  ICONS: '#878787',
  ICON_COLOR: '#8B8B8B',

  // Disabled modifier/item background (GridItem.tsx uses this)
  DISABLED_BG: '#D7D7D7',

  // Error / success
  RED: '#E21508',
  ERROR: '#E21508',
  RED_COUNT: '#F08A83',
  GREEN: '#00984F',
  GREEN_100: '#007B40',
  successText: '#00984F',

  // Yellow / orange (POS theme)
  YELLOW_OPACITY: '#FFF7DA',
  PRIMARY_OLD: '#FF8A00',

  // Opacity / hover
  PRIMARY_OPACITY: 'rgba(61, 61, 61, 0.2)',
  MODAL_BACKDROP: 'rgba(0, 0, 0, 0.8)',
  RIPPLE_COLOR: 'rgba(0, 0, 0, 0.32)',
  PRIMARY_RIPPLE: 'rgba(211, 211, 211, 0.3)',

  // Button hover (darker than PRIMARY) – used in POS-style buttons
  PRIMARY_HOVER: '#2A2A2A',

  // UI surfaces used in POS (ActionBar, panels)
  ACTION_BAR_BG: '#F5F5F0',
  BORDER_LIGHT: '#D7D7D7',

  // Category/Product/Modifier button backgrounds – POS uses PNG assets;
  // these are fallback hex approximations where assets aren’t available.
  CATEGORY_BG: '#5C6BC0',
  CATEGORY_BG_SELECTED: '#3949AB',
  CATEGORY_BG_HOVER: '#7986CB',
  PRODUCT_BG: '#FFB74D',
  PRODUCT_BG_SELECTED: '#FF9800',
  PRODUCT_BG_HOVER: '#FFCC80',
  MODIFIER_BG: '#EDAFAF',
  MODIFIER_BG_SELECTED: '#E8A0A0',
  MODIFIER_BG_HOVER: '#E29E9E',
};

export default POS_COLORS;
